export class PermissionError extends Error {
    public readonly name = 'PermissionError';
    public constructor(message: string) {
        super(message);
        Object.setPrototypeOf(this, PermissionError.prototype);
    }
}
